export default "__VITE_ASSET__B2rzDg8I__"